module.exports = __webpack_public_path__ + "static/media/0504481e-774c-4e57-a055-c94bb5303380.32570820.ttf";